import { Routes, Route } from "react-router-dom";
import Quiz from "../pages/Quiz";
import Home from "../pages/Home";
import Promotion from "../pages/Promotion";
import DownloadApp from "../pages/DownloadApp";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import ServiceTerms from "../pages/ServiceTerms";
import Checkout from "../pages/Checkout";

function RoutesApp() {

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/quiz" element={<Quiz />} />
      <Route path="/promotion" element={<Promotion />} />
      <Route path="/downloadApp" element={<DownloadApp />} />
      <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
      <Route path="/serviceTerms" element={<ServiceTerms />} />
      <Route path="/checkout" element={<Checkout />} />
    </Routes>
  );
}
export default RoutesApp;
